import { AccountPayableModel } from 'api-hooks/account-payable';
import { AccountReceivableModel } from 'api-hooks/account-receivable';
import { ActivityPurchaseModel } from 'api-hooks/order/activity';
import { PurchaseModel } from 'api-hooks/order/common';
import { CruisePurchaseModel } from 'api-hooks/order/cruise';
import { HotelPurchaseModel } from 'api-hooks/order/hotel';
import { FlightPurchaseModel } from 'api-hooks/order/ticket-order';
import { DocumentPurchaseModel } from 'api-hooks/order/travel-document';
import { OrderAdjustmentModel } from 'api-hooks/order-adjustment';
import { OtherExpensesModel } from 'api-hooks/other-expense';
import { OtherIncomeModel } from 'api-hooks/other-income';
import { ProductPurchaseModel } from 'api-hooks/product/order';
import { ProductSalesModel } from 'api-hooks/product/sales';
import { ProjectModel } from 'api-hooks/projects';
import { ReceiptModel } from 'api-hooks/receipt';
import {
  RefundModel,
  ReleasePurchaseModel,
  ReleaseSaleModel,
} from 'api-hooks/refund/refund';
import { RefundReleaseAgentModel } from 'api-hooks/refund/refund-release-agent';
import { RefundReleaseUserModel } from 'api-hooks/refund/refund-release-user';
import { ActivitySaleModel } from 'api-hooks/sale/activity';
import { SaleModel } from 'api-hooks/sale/common';
import { CruiseSaleModel } from 'api-hooks/sale/cruise';
import { HotelSaleModel } from 'api-hooks/sale/hotel';
import { TicketSaleModel } from 'api-hooks/sale/ticket-sale';
import { TravelDocumentSalesModel } from 'api-hooks/sale/travel-document';
import { TourModel } from 'api-hooks/tour/tour-list/tour-detail';
import { TourSalesModel } from 'api-hooks/tour/tour-sale';
import { BalanceAdjustmentModel } from 'api-hooks/transactions/balance-adjustment';
import { BankTransactionModel } from 'api-hooks/transactions/bank-transaction';
import { CashTransactionModel } from 'api-hooks/transactions/cash-transaction';
import { TransferModel } from 'api-hooks/transactions/transfer';

export type ApprovableType =
  | 'account-payables'
  | 'account-receivables'
  | 'activity-purchases'
  | 'activity-sales'
  | 'balance-adjustments'
  | 'bank-transactions'
  | 'cash-transactions'
  | 'cruise-purchases'
  | 'cruise-sales'
  | 'document-purchases'
  | 'document-sales'
  | 'flight-purchases'
  | 'flight-sales'
  | 'hotel-purchases'
  | 'hotel-sales'
  | 'order-adjustments'
  | 'other-expenses'
  | 'other-incomes'
  | 'product-purchases'
  | 'product-sales'
  | 'projects'
  | 'receipts'
  | 'tour-sales'
  | 'refunds'
  | 'release-sales'
  | 'release-purchases'
  | 'transfers'
  | 'tours';

export type VoidableType =
  | 'account-payables'
  | 'account-receivables'
  | 'activity-purchases'
  | 'activity-sales'
  | 'balance-adjustments'
  | 'bank-transactions'
  | 'cash-transactions'
  | 'cruise-purchases'
  | 'cruise-sales'
  | 'document-purchases'
  | 'document-sales'
  | 'flight-purchases'
  | 'flight-sales'
  | 'hotel-purchases'
  | 'hotel-sales'
  | 'order-adjustments'
  | 'other-expenses'
  | 'other-incomes'
  | 'product-purchases'
  | 'product-sales'
  | 'receipts'
  | 'tour-sales'
  | 'transfers';

export type SaleType =
  | 'activity-sales'
  | 'cruise-sales'
  | 'document-sales'
  | 'flight-sales'
  | 'hotel-sales'
  | 'product-sales'
  | 'tour-sales';

export type PurchaseType =
  | 'activity-purchases'
  | 'cruise-purchases'
  | 'document-purchases'
  | 'flight-purchases'
  | 'hotel-purchases'
  | 'product-purchases';

export type RevertVoidableType =
  | 'activity-purchases'
  | 'activity-sales'
  | 'cruise-purchases'
  | 'cruise-sales'
  | 'document-purchases'
  | 'document-sales'
  | 'flight-purchases'
  | 'flight-sales'
  | 'hotel-purchases'
  | 'hotel-sales'
  | 'product-purchases'
  | 'product-sales'
  | 'tour-sales';

export type ResolveableType =
  | 'account-payables'
  | 'account-receivables'
  | 'activity-purchases'
  | 'activity-sales'
  | 'balance-adjustments'
  | 'bank-transactions'
  | 'cash-transactions'
  | 'cruise-purchases'
  | 'cruise-sales'
  | 'document-purchases'
  | 'document-sales'
  | 'flight-purchases'
  | 'flight-sales'
  | 'hotel-purchases'
  | 'hotel-sales'
  | 'order-adjustments'
  | 'product-purchases'
  | 'product-sales'
  | 'receipts'
  | 'refunds'
  | 'release-purchases'
  | 'release-sales'
  | 'tour-sales'
  | 'transfers';

export type CompleteableType =
  | 'activity-sales'
  | 'cruise-sales'
  | 'document-sales'
  | 'flight-sales'
  | 'hotel-sales'
  | 'product-sales'
  | 'projects'
  | 'tour-sales';

export type DestroyableType =
  | 'activities'
  | 'agents'
  | 'airlines'
  | 'approvals'
  | 'bank-accounts'
  | 'cash-accounts'
  | 'cheque-giros'
  | 'cruises'
  | 'customers'
  | 'employees'
  | 'guests'
  | 'hotels'
  | 'payment-channels'
  | 'preference-groups'
  | 'products'
  | 'product-adjustments'
  | 'roles'
  | 'transaction-categories'
  | 'tour-categories'
  | 'visa-documents'
  | 'bonus-periods'
  | 'commission-masters';

export type SalesActionsType =
  | 'flight-sales'
  | 'hotel-sales'
  | 'cruise-sales'
  | 'document-sales'
  | 'activity-sales'
  | 'product-sales'
  | 'tour-sales';

export type PurchasesActionsType =
  | 'flight-purchases'
  | 'hotel-purchases'
  | 'cruise-purchases'
  | 'document-purchases'
  | 'activity-purchases'
  | 'product-purchases';

export type PrintableInvoiceType =
  | 'flight-sales'
  | 'hotel-sales'
  | 'cruise-sales'
  | 'document-sales'
  | 'activity-sales'
  | 'product-sales'
  | 'tour-sales';

export type PrintableVoucherType = 'hotel-sales';

export type VoidableMutationInput = {
  type: VoidableType;
  id: string;
};

export type ResolveableMutationInput = {
  type: ResolveableType;
  id: string;
};

export type CompleteableMutationInput = {
  type: CompleteableType;
  id: string;
};

export type RevertCompleteableMutationInput = {
  type: CompleteableType;
  id: string;
};

export type DestroyableMutationInput = {
  type: DestroyableType;
  id: string;
};

export type RevertDraftMutationInput = {
  id: string;
  type: ApprovableType;
};

export type RevertVoidMutationInput = {
  id: string;
  type: RevertVoidableType;
};

export class PrintInvoiceMutationInput {
  id: string;
  type: PrintableInvoiceType;
  body: {
    showDate: boolean;
  };
}

export class PrintVoucherMutationInput {
  id: string;
  type: PrintableVoucherType;
}

export type ModelApprovalable =
  | SaleModel //general sales
  | PurchaseModel // general purchases
  | AccountPayableModel
  | AccountReceivableModel
  | ActivityPurchaseModel
  | ActivitySaleModel
  | BalanceAdjustmentModel
  | BankTransactionModel
  | CashTransactionModel
  | CruisePurchaseModel
  | CruiseSaleModel
  | DocumentPurchaseModel
  | TravelDocumentSalesModel
  | TicketSaleModel
  | FlightPurchaseModel
  | HotelPurchaseModel
  | ProductSalesModel
  | HotelSaleModel
  | OrderAdjustmentModel
  | ProductPurchaseModel
  | ProductSalesModel
  | ProjectModel
  | ReceiptModel
  | RefundReleaseAgentModel
  | RefundReleaseUserModel
  | ReleasePurchaseModel
  | ReleaseSaleModel
  | RefundModel
  | TourSalesModel
  | TourModel
  | TransferModel
  | OtherIncomeModel
  | OtherExpensesModel;

export enum ExportableReportType {
  Sale = 'sale',
  Income = 'income',
  Purchase = 'purchase',
  AccountReceivable = 'account-receivable',
  AccountReceivableRegular = 'account-receivable-regular',
  AccountPayable = 'account-payable',
  AccountPayableRegular = 'account-payable-regular',
  Flights = 'flights',
  Hotel = 'hotel',
  Tour = 'tour',
  Project = 'project',
  BankMutation = 'bank-mutation',
  CashMutation = 'cash-mutation',
  TransactionMutation = 'transaction-mutation',
  AgentMutation = 'agent-mutation',
  CustomerMutation = 'customer-mutation',
  ProfitLossMutation = 'profit-loss-mutation',
  Passport = 'passport-travel-document',
  Visa = 'visa-travel-document',
  ApecCard = 'apec-card-travel-document',
  Insurance = 'insurance-travel-document',
}
